import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--extranarrow _my-6 js-main-content" }
const _hoisted_2 = { class: "gfu-content-head" }
const _hoisted_3 = {
  class: "gfu-hd gfu-hd--h1",
  "data-qa": "page-title"
}
const _hoisted_4 = { class: "gfu-box _mt-3 _mb-6 _flexcol _gap-3" }
const _hoisted_5 = {
  class: "gfu-filters",
  "data-qa": "faq-search"
}
const _hoisted_6 = {
  key: 0,
  class: "_tc--light _mt-3"
}
const _hoisted_7 = {
  key: 1,
  class: "gfu-issues-empty-result _tac",
  "data-qa": "faq-page-no-content"
}
const _hoisted_8 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_benefits_and_risks = _resolveComponent("project-benefits-and-risks")
  const _component_text_field = _resolveComponent("text-field")
  const _component_faq_feedback_actions = _resolveComponent("faq-feedback-actions")
  const _component_faq_box = _resolveComponent("faq-box")
  const _component_empty_state = _resolveComponent("empty-state")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.Resources.Faq.FaqPageHeader), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_project_benefits_and_risks),
      ($options.hasQuestions)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_text_field, {
                modelValue: $data.searchTerm,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.searchTerm) = $event)),
                class: "gfu-flex__item--grow _mt-0",
                "display-name": _ctx.Resources.Faq.SearchFaqTopicsLabel,
                placeholder: _ctx.Resources.Faq.SearchFaqTopicsPlaceholder,
                "auto-complete": "off"
              }, null, 8 /* PROPS */, ["modelValue", "display-name", "placeholder"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.formattedFaqSections, (question) => {
              return (_openBlock(), _createElementBlock("div", {
                key: question.projectFaqSectionID
              }, [
                _createVNode(_component_faq_box, {
                  title: question.header,
                  description: question.content,
                  "search-term": $data.searchTerm,
                  "is-initially-collapsed": question.isCollapsed,
                  "data-qa": `question-id:${question.projectFaqSectionID}`
                }, {
                  default: _withCtx(() => [
                    (question.editedAt)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.Resources.Common.LastUpdatedAtLabel) + " " + _toDisplayString(question.editedAtDateFormatted), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_faq_feedback_actions, {
                      section: question,
                      "project-name": $options.projectName,
                      onNegativeFeedbackClick: $options.onNegativeFeedbackClick,
                      onUsefulnessMarked: $options.onUsefulnessMarked
                    }, null, 8 /* PROPS */, ["section", "project-name", "onNegativeFeedbackClick", "onUsefulnessMarked"])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "description", "search-term", "is-initially-collapsed", "data-qa"])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_empty_state, {
              title: _ctx.Resources.Faq.FaqUserEmptyStateTitle,
              description: _ctx.Resources.Faq.FaqUserEmptyStateParagraph,
              "data-qa": "empty-faq-customer"
            }, {
              default: _withCtx(() => [
                ($setup.isNotCrowdfundingDraftPhase)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "gfu-btn gfu-btn--accent gfu-btn--soft gfu-btn--wide",
                      href: $options.topicSelectionContactUrl,
                      "data-qa": "faq-page-button:AskTheCreator"
                    }, _toDisplayString(_ctx.Resources.Faq.FaqUserEmptyStateButton), 9 /* TEXT, PROPS */, _hoisted_8))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "description"])
          ]))
    ])
  ]))
}